export default {
  fields: {
    price: 'Prijs',
    tax: 'Btw',
    visible_to: 'Zichtbaar voor',
  },
  buttons: {
    add_price: '+ Prijs toevoegen',
  },
};
